export default function (maps, value) {
  const retMap = {}
  Object.entries(maps).forEach((map) => {
    const [key, mapKey] = map
    retMap[key] = value[mapKey]
  })
  return retMap
}
